import { ItemStatusEnum } from '../../enum/item-status.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ItemData {
  ContractId: string;
  QuoteId: string;
  QuoteNumber: string;
  ItemId: string;
  ActualHours: number;
  AllocatedHours: number;
  ItemName: string;
  ItemNumber: string;
  ItemStatus: ItemStatusEnum;
  Estimator: string;
}


